//import logo from './logo.svg';
import './App.css';
import ISWidget from './components/ISWidget';

function App() {
  return (
    <div className="App">
      <ISWidget />
    </div>
  );
}

export default App;
